<template>
	<div class="myVideo">
		<video class="myVideo" ref="videoEle" controls  width="600"></video>
	</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import Hls from 'hls.js'

export default {
	props: {
		url: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			hls: null,
			video: null,
			timer: null
		}
	},
	created() {},
	watch: {
		url: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.initializePlayer()
				}
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.initializePlayer()
		})
	},
	beforeUnmount() {
		if (this.hls) {
			this.hls.destroy()
		}
		clearTimeout(this.timer)
	},
	methods: {
		initializePlayer() {
			this.video = this.$refs.videoEle
			if (!this.url) {
				this.showLoadingIndicator()
				return
			}
			this.hlsPlay()
		},
		showLoadingIndicator() {
			console.log('正在加载视频...')
		},
		hlsPlay() {
			this.video = this.$refs.videoEle
			if (Hls.isSupported()) {
				this.hls = new Hls()
				this.hls.loadSource(this.url)
				this.hls.attachMedia(this.video)
				this.hls.on(Hls.Events.BUFFERING, (event, data) => {
					console.log('缓冲中...')
				})
				this.hls.on(Hls.Events.MANIFEST_LOADED, (event, data) => {
					console.log('播放列表已更新，尝试恢复播放')
					if (!this.video.paused) {
						this.video.play()
					}
				})
				this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
					this.timer = setTimeout(() => {
						this.video.play()
					}, 500)
				})
			} else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
				this.video.src = this.url
				this.video.addEventListener('canplay', () => {
					this.timer = setTimeout(() => {
						this.video.play()
					}, 500)
				})
			}
		}
	},
}
</script>

<style>
.myVideo {
	width: 100%;
	height: 100%;
}
</style>